import { config } from "./config";
import axios from "axios";
import { createAPIError, handleAxiosError } from "./utils/error.utils";
import { UnexpectedAPIError } from "./errors";
export const roles = (() => {
    async function create(role) {
        if (role && "name" in role) {
            try {
                const response = await axios.post(baseUrl(), role);
                if (response.status === 201)
                    return response.data;
                else
                    throw response.data;
            }
            catch (error) {
                if (error.response)
                    handleAxiosError(error.response);
                else
                    throw UnexpectedAPIError;
            }
        }
        else {
            throw [
                createAPIError("incorrect_data", "please provide a object with a name"),
            ];
        }
    }
    async function queryRoles(query) {
        const { role, ...params } = query;
        //normalize role
        if (role && typeof role !== "string" && "name" in role) {
            params["name"] = role.name;
        }
        else if (role && typeof role === "string") {
            params["name"] = role;
        }
        const requestConfig = { params: params };
        try {
            const response = await axios.get(baseUrl(), requestConfig);
            if (response.status === 200)
                return response.data;
            else
                throw response.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function update(role) {
        try {
            const url = `${baseUrl()}/${role.id}`;
            const response = await axios.put(url, role);
            if (response.status === 200)
                return role;
            else
                throw response.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function remove(idOrRole) {
        if (idOrRole && typeof idOrRole !== "number") {
            idOrRole = idOrRole.id;
        }
        if (typeof idOrRole === "number") {
            try {
                const url = `${baseUrl()}/${idOrRole}`;
                const response = await axios.delete(url);
                if (response.status === 200)
                    return;
                else
                    throw response.data;
            }
            catch (error) {
                if (error.response)
                    handleAxiosError(error.response);
                else
                    throw UnexpectedAPIError;
            }
        }
        throw [
            createAPIError("incorrect_data", "please provide an id, or a (role) object with id"),
        ];
    }
    function baseUrl() {
        return `${config.fullUrl()}/roles`;
    }
    return {
        create: create,
        query: queryRoles,
        update: update,
        delete: remove,
    };
})();
